import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import { Home } from "./Components/Home";
import { Navigation } from "./Components/Navigation";
import { Contact } from "./Components/Contact";
import { Footer } from "./Components/Footer";
import { UserProvider } from "./user";
import { Music } from "./Components/Music";
import { Menu } from "./Components/Menu";
import { Location } from "./Components/Map";
import { SpeedInsights } from "@vercel/speed-insights/react";

function App() {
  const settings = { language: "es" };
  return (
    <UserProvider settings={settings}>
      <Router>
        <Navigation />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/music" element={<Music />} />
            <Route path="/location" element={<Location />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer />
      </Router>
      <SpeedInsights />
    </UserProvider>
  );
}

export default App;
